import Home from "./pages/Home";
import About from "./pages/About";
import SharedSafariList from "./components/SharedSafari/SharedSafariList";
import ArticalList from "./components/Home/artical_list/ArticalList";
import ArticalCardDetaile from "./components/Home/artical_list/ArticalCardDetaile";
import Faq from "./pages/Faq";
import ContactUs from "./pages/ContactUs";
import SafariPackage from "./components/safaripackages/list/SafariPackage";
import AllParkLists from "./components/parks/AllParkLists";
import SafariParkView from "./components/parks/parkview/SafariParkView";
import SharedSafariDetailCard from "./components/parks/parkview/safaris/ParkSharedSafaries";
import AnimalSafariList from "./components/Animal_Safari/AnimalSafariList";
import AnimalDetail from "./components/Animal_Safari/AnimalDetails/AnimalDetail";
import Privacy from "./pages/Privacy";
import TermsCondition from "./pages/TermsCondition";
import Account from "./components/common/Account";
import Wishlist from "./pages/Wishlist";
import SafariTourOperator from "./pages/SafariTourOperator";
import PrivacyAccount from "./components/common/Accounts/Privacy";
import BlockedMember from "./components/common/Accounts/BlockedMember";
import Messages from "./components/message/Messages";
import SafariTourOperatorsTabs from "./components/safaritouroperator/SafariTourOperatorsDetails";
import ArticalCategory from "./components/Home/artical_list/ArticalCategory";
import Follower from "./components/common/Follower";
import Following from "./components/common/Following";
import ShareSafariView from "components/SharedSafari/view/ShareSafariView";
import PackageView from "components/safaripackages/view/PackageView";
import PrivateRoute from "components/PrivateRoute";
import UserProfile from "components/userprofile/UserProfile";
import AccountOperator from "components/common/AccountOperator";
import RefundPolicy from "pages/RefundPolicy";
import CancellationPolicy from "pages/CancellationPolicy";
import Feed1 from "components/feeds/Feed1";
import Feed2 from "components/feeds/Feed2";
import Feed3 from "components/feeds/Feed3";




const routes = [
  { path: "/", element: <Home /> },

  //Parks
  { path: "/park", element: <AllParkLists /> },
  { path: "/park/:parkSlug", element: <SafariParkView /> },

  //Packages
  { path: "/package", element: <SafariPackage /> },
  { path: "/package/:safarioperator/:packSlug", element: <PackageView /> },

  //shared safari
  { path: "/sharesafari", element: <SharedSafariList /> },
  { path: "/sharedsafari/:organized_slug/:safariSlug", element: <ShareSafariView /> },

  //user Profile
  { path: "/profile/user/:user_handle", element: (<UserProfile />) },
  { path: "/account", element: (<PrivateRoute> <Account /> </PrivateRoute>) }, //for Edit User Profile

  //Operator
  { path: "/operator/:slug/profile/:tabslug?", element: <SafariTourOperator />, },
  { path: "/manage", element: (<PrivateRoute> <AccountOperator /> </PrivateRoute>) }, //for Edit User Profile
  // { path: "/operator/:slug/gallery", element: (<PrivateRoute> <OperatorGallery /> </PrivateRoute>) },

  { path: "/animal/:animalSlug", element: <AnimalSafariList /> },
  { path: "/animaldetail", element: <AnimalDetail /> },
  { path: "/privacy-policy", element: <Privacy /> },


  { path: "/article", element: <ArticalList /> },
  { path: "/article/topic/animal", element: <ArticalCategory /> },
  { path: "/article/:articleId", element: <ArticalCardDetaile /> },

  { path: "/about-us", element: <About /> },
  { path: "/faq", element: <Faq /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/terms-of-use", element: <TermsCondition /> },
  { path: "/refund-and-cancellation-policy", element: <RefundPolicy /> },
  { path: "/cancellation-policy", element: <CancellationPolicy /> },

  { path: "/profile/follower/user", element: (<PrivateRoute><Follower /></PrivateRoute>) },
  { path: "/profile/following/user", element: (<PrivateRoute><Following /></PrivateRoute>) },

  { path: "/chat", element: (<PrivateRoute> <Messages /> </PrivateRoute>) },
  // { path: "/account/notification", element: (<PrivateRoute> <AllNotification /> </PrivateRoute>) },
  { path: "/account/privacy", element: (<PrivateRoute><PrivacyAccount /></PrivateRoute>) },
  { path: "/account/blocked-member", element: (<PrivateRoute><BlockedMember /></PrivateRoute>) },
  { path: "/account/wishlist/:tabslug?", element: (<PrivateRoute><Wishlist /></PrivateRoute>) },
  { path: "/park/bandhavgarh-tiger-reserve/sharedsafari", element: <SharedSafariDetailCard />, },
  { path: "/safariTourOperatorsTab", element: <SafariTourOperatorsTabs /> },
  { path: "/feed1", element: (<Feed1 />) },
  { path: "/feed2", element: (<Feed2 />) },
  { path: "/feed3", element: (<Feed3 />)  },
];

export default routes;
